import type { OfferData } from './SendOfferModal'

/**
 * The POST /marketer/collaborations body for an offer from SendOfferModal, minus where it
 * goes (campaignId or threadId) and who it's for (athleteId). Throws if licensing is on with
 * no platform chosen.
 */
export const offerRequestBody = (offerData: OfferData) => {
  let licensingOffer = null
  if (offerData.licensing?.enabled) {
    const { platforms, territory, term } = offerData.licensing
    if (platforms.length === 0) {
      throw new Error('Please select at least one platform for licensing')
    }
    licensingOffer = {
      platforms: platforms.map((p) => ({
        platform: p,
        usage_permission: ['Website', 'Email', 'Ads'], // Default permissions
        territory,
        usage_term_days: parseInt(term),
        fee: offerData.licensing.fee ?? 0,
      })),
      message: 'Licensing included in initial offer',
    }
  }

  return {
    paymentType: offerData.paymentType,
    paymentAmount: offerData.paymentType === 'fixed' ? (offerData.amount ?? undefined) : undefined,
    customPaymentTerms:
      offerData.paymentType === 'custom' ? offerData.customPaymentTerms : undefined,
    contentDueDate: offerData.dueDate || undefined,
    message: offerData.message || undefined,
    structuredDeliverables: offerData.deliverables.length > 0 ? offerData.deliverables : undefined,
    licensing: offerData.licensing?.enabled,
    licensingOffer,
    booking: offerData.booking,
  }
}
